// extracted by mini-css-extract-plugin
export default {"buttonAddClass":"style_buttonAddClass__VtCk2","addButton":"style_addButton__SJCiF"};